import { lt } from '@mews/framework';
import { Link, Typography } from '@optimus-web/core';
import { RouteName } from '@mews-commander/enums';
import { useResolveRoute } from '@mews/routing';

export const CentralCreatePolicyLinks = () => {
    const resolveRoute = useResolveRoute();
    const paymentPoliciesLink = resolveRoute(RouteName.EnterprisePaymentPoliciesIndex);
    const cancellationPoliciesLink = resolveRoute(RouteName.EnterpriseCancellationPoliciesIndex);

    return (
        <Typography textStyle="bodyMedium" variant="secondary" as="div">
            {lt('PortfolioPolicyExceptionFormPolicyHelper', {
                paymentPoliciesLink: (text) => (
                    <Link href={paymentPoliciesLink} target="_blank" rel="noreferrer">
                        {text}
                    </Link>
                ),
                cancellationPoliciesLink: (text) => (
                    <Link href={cancellationPoliciesLink} target="_blank" rel="noreferrer">
                        {text}
                    </Link>
                ),
            })}
        </Typography>
    );
};
